import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { withSuspense, useAuth } from '@monument/core';

const lazy = callback => withSuspense(React.lazy(callback));

const SignupRoute = lazy(() =>
  import('@routes/signup/SignupRoute').then(module => ({ default: module.SignupRoute })),
);
const OnboardingRoute = lazy(() =>
  import('@routes/onboarding/OnboardingRoute').then(module => ({
    default: module.OnboardingRoute,
  })),
);
const DashboardRoute = lazy(() =>
  import('@routes/dashboard/Dashboard').then(module => ({ default: module.Dashboard })),
);
const CareChatRoute = lazy(() =>
  import('@routes/care/chat/MessengerRoute').then(module => ({ default: module.MessengerRoute })),
);
const CareSessionRoute = lazy(() =>
  import('@routes/care/session/CareSessionRoute').then(module => ({
    default: module.CareSessionRoute,
  })),
);
const SettingsRoute = lazy(() =>
  import('@routes/settings/SettingsRoute').then(module => ({ default: module.SettingsRoute })),
);
const CookieListRoute = lazy(() =>
  import('@routes/cookie-list/CookieListRoute').then(module => ({
    default: module.CookieListRoute,
  })),
);
const NotFoundRoute = lazy(() =>
  import('@routes/not-found/NotFoundRoute').then(module => ({ default: module.NotFoundRoute })),
);
const InsuranceSubmissionRoute = lazy(() =>
  import('@routes/insurance-submission/InsuranceSubmissionRoute').then(module => ({
    default: module.InsuranceSubmissionRoute,
  })),
);
const InsuranceCardImagesRoute = lazy(() =>
  import('@routes/insurance/InsuranceCardImagesRoute').then(module => ({
    default: module.InsuranceCardImagesRoute,
  })),
);
const FillSubjectiveNotesRoute = lazy(() =>
  import('@routes/subjective-notes/FillSubjectiveNotesRoute').then(module => ({
    default: module.FillSubjectiveNotesRoute,
  })),
);
const RedirectToDashBoard = () => <Redirect to="/dashboard" />;

export default function InitializeRouter() {
  const { isAuthenticated } = useAuth();

  return (
    <>
      <Switch>
        <Route path="/signup" component={isAuthenticated ? RedirectToDashBoard : SignupRoute} />
        <Route path="/onboarding" component={OnboardingRoute} />
        <Route path="/insurance-submission" component={InsuranceSubmissionRoute} />
        <Route path="/dashboard" component={DashboardRoute} />
        <Route path="/care/session" component={CareSessionRoute} />
        <Route path="/care/chat" component={CareChatRoute} />
        <Route path="/insurance/card-images" component={InsuranceCardImagesRoute} />
        <Route path="/settings" component={SettingsRoute} />
        <Route path="/cookie-list" component={CookieListRoute} />
        <Route path="/subjective-notes/fill/:id" component={FillSubjectiveNotesRoute} />
        <Redirect exact from="/" to="/dashboard" />
        {/* Redirects for legacy routes. Can probably remove after a while. */}
        <Route path="/partner" component={isAuthenticated ? RedirectToDashBoard : SignupRoute} />
        <Redirect from="/register" to="/signup/intro" exact />
        <Redirect from="/chat" to="/care/chat" exact />
        <Redirect from="/video-chat" to="/care/session" exact />
        <Redirect from="/care/all-prescriptions" to="/settings/medical-info" exact />
        <Redirect from="/care/appointments" to="/dashboard" exact />
        <Redirect from="/care/past-appointments" to="/settings/payment" exact />
        <Redirect from="/care/prescriptions" to="/settings/medical-info" exact />
        <Redirect from="/treatment-timeline" to="/dashboard" />
        <Redirect from="/treatment-information" to="/dashboard" />
        <Redirect from="/goals-and-progress/:type?" to="/dashboard" />
        <Redirect from="/courses/:courseSlug/lessons/:lessonSlug" to="/dashboard" />
        <Redirect from="/courses/:courseSlug" to="/dashboard" />
        <Redirect from="/courses" to="/dashboard" />
        <Redirect from="/community/:channelId?" to="/dashboard" />
        <Redirect from="/groups/:slug" exact to="/dashboard" />
        <Redirect from="/groups" exact to="/dashboard" />
        <Redirect from="/groups/:id/session" to="/dashboard" />
        <Redirect from="/reviews/:type?/:page?" to="/dashboard" />
        <Redirect from="/assessment/therapy" to="/dashboard" />
        {/* End legacy redirects. */}
        <Route path="*" component={NotFoundRoute} />
      </Switch>
    </>
  );
}
